import { render } from "./Other.vue?vue&type=template&id=b0b10812&scoped=true"
import script from "./Other.vue?vue&type=script&lang=js"
export * from "./Other.vue?vue&type=script&lang=js"

import "./Other.vue?vue&type=style&index=0&id=b0b10812&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b0b10812"

export default script